package game.entity

import game.Game
import game.Room

class EntityDeath(val entity: Entity, val sound: String? = "enemy-death") : Entity() {
    val deathAnimations = mutableListOf<AnimationEntity>()
    var coolDown = 0

    override fun onInit(game: Game, room: Room) {
        for (animationRow in 0 until entity.height) {
            for (animationCol in 0 until entity.width)
                deathAnimations.add(
                    AnimationEntity().apply {
                        col = entity.col + animationCol
                        row = entity.row + animationRow
                        sprite = game.getSpriteById("enemy-death")
                    }
                )
        }

        deathAnimations.shuffle()
    }

    override fun onTick(game: Game, room: Room) {
        if (coolDown > 0 ) {
            coolDown--
        } else {
            playNextAnimation(game, room)
            coolDown = 12
        }
     }

    private fun playNextAnimation(game: Game, room: Room) {
        if (deathAnimations.isNotEmpty()) {
            val nextAnimation = deathAnimations.removeAt(0)
            room.addEntity(nextAnimation)
            if (sound != null) {
                game.playSound(sound)
            }
        } else {
            room.removeEntity(this)
        }
    }
}